import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DocketFilterService, IFilterObject } from 'src/app/api/core/docket-filter/docket-filter.service';
import { DocketService } from 'src/app/api/core/docket/docket.service';
import { APP_DOCKET_DISPLAY_UPDATE } from 'src/app/api/utils/watcher/watcher-event';
import { WatcherService } from 'src/app/api/utils/watcher/watcher.service';
import { Order } from 'src/app/models/order.model';
import { CommsService } from '../../../../utils/comms/comms.service';
import { AuthService } from '../../../auth/auth.service';
import { CoreService } from '../../../core/core.service';
import { FeatureFlagList, FeatureFlagsService } from '../../../settings/feature-flags.service';

import each from 'lodash/each';
import find from 'lodash/find';
import size from 'lodash/size';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { BffService } from 'src/app/api/utils/comms/bff/bff.service';
import { BffDispatchRequest, OrderDispatcherService } from '../order-dispatcher/order-dispatcher.service';

@Injectable({
  providedIn: 'root',
})
export class DispatchPrintedService extends OrderDispatcherService {
  constructor(
    public watcher: WatcherService,
    public comms: CommsService,
    public auth: AuthService,
    public core: CoreService,
    public docketService: DocketService,
    public filterService: DocketFilterService,
    public featureFlagsService: FeatureFlagsService,
    public bffService: BffService,
  ) {
    super(core, docketService, auth, bffService);
  }

  /**
   * Updates the printed status of the orders. Unlike the set ETA, a failed response here will not reset the
   * printed status of the orders.
   * @param orderIds - The list of order ids to set
   * @param status - The printed status to set
   */
  async updateDocketPrintStatus(orderIds: string[], status: boolean, allowPendingState: boolean = true): Promise<any> {
    return new Promise(resolve => {
      // setup object to send - with bump screen ID, return order obj :NO, & ETA array
      let sendObj: any = {
        bump_screen_id: this.auth.Active_bump_screen.id,
        return_orders: true,
        orders: [],
      };

      const { bump_status } = this.filterService.getSelectedFilters();
      const bumpFilter: IFilterObject = find(bump_status, 'toggled');

      each(orderIds, (id: string) => {
        const order: Order = this.docketService.getOrderById(id);
        order.printed = status;
        order.setPending(allowPendingState && order.auto_set_eta && bumpFilter && bumpFilter.data == 'new');

        if (order) {
          // set the type
          if (order.type == 'batch_order') {
            sendObj.type = order.type;
            sendObj.batch_id = order.id;
            sendObj.bump_status = order.bump_status;
            sendObj.printed = status;
          } else {
            // create the order request
            sendObj.orders.push({
              id: order.id,
              bump_status: order.bump_status,
              printed: status,
            });
          }
        }
      });

      // force a list update
      this.watcher.broadcast(APP_DOCKET_DISPLAY_UPDATE, 'updateDocketEta');

      if (size(sendObj.orders) || sendObj.type == 'batch_order') {
        let sendPrintedResponse: Observable<any> = this.updateOrder_Drupal(sendObj);

        // separate BFF FALL
        if (this.featureFlagsService.isFeatureFlagEnabled(FeatureFlagList.BFF)) {
          this.dispatchDocket(orderIds, BffDispatchRequest.PRINTED).subscribe(
            bffPayload => {
              console.log('BFF PRINTED Success:', bffPayload);
              // trackevents
            },
            bffFailed => {
              console.log('BFF PRINTED Failed:', bffFailed);
              // trackevents
            },
          );
        }

        sendPrintedResponse.pipe(take(1)).subscribe(
          payload => {
            // block propagation of response if user already logged out
            if (!this.auth.Logged_in) {
              resolve(false);
              return;
            }

            if (payload && payload.success) {
              if (payload.orders) {
                this.docketService.updateOrders(payload.orders, false);
              }
              resolve(true);
            } else {
              // show some error
              resolve(false);
            }
          },
          fail => {
            resolve(false);
          },
        );
      } else {
        // order not found
        resolve(false);
      }
    });
  }

  updateOrder_Drupal(sendObj: any): Observable<any> {
    return new Observable(subscriber => {
      const header = new HttpHeaders(this.auth.headerData);
      this.comms.post(
        this.core.Active_server.url + 'api/bump/orders/v3',
        sendObj,
        {
          headers: header,
        },
        payload => {
          subscriber.next();
          subscriber.complete();
        },
        err => {
          subscriber.error(err);
          subscriber.complete();
        },
      );
    });
  }
}
